<template>
    <div class="share_page">
        <div class="head_backgund">
            <span>满足您的商务社交需求</span>
            <p>Business social needs</p>
        </div>
        <div class="pageCenter">
            <div v-show="isShow">
                <h5 class="head_title">App模板 <button @click="search">搜索</button><input type="text"
                        placeholder="请输入名称或编号" v-model="val" @keyup.enter="search"></h5>
                <div class="share_content" v-for="(item,index) in arr" :key="index">
                    <img :src=item.imageFront @click="details(item)">
                    <span>编号：{{item.cardNo}}</span>
                </div>
                <div class="share_foot">
                    <div class="page-btn" :class="{'none': currentIndex == 1}" @click="previous">上一页</div>
                    <div class="page-btn" v-for="(item,index) of pageList" :key="index"
                        :class="{'act':currentIndex == item,'more':item == '...'}" @click="current(item)">{{item}}</div>
                    <div class="page-btn" :class="{'none': total <= currentIndex}" @click="next">下一页</div>

                </div>
            </div>
            <div v-show="!isShow" class="details">
                <div class="detailsConten" @click.stop="details">
                    <h4 class="detailHead">模板详情 <span @click.stop="details" class="detailHeadRight"></span></h4>
                    <div class="detailBody">
                        <div class="detailBodyContent" @click.stop="back">
                            <img :src="imgUrl">
                        </div>
                    </div>
                    <div class="detailBodyRight">
                        <button @click.stop="back"></button>
                        <button @click.stop="down">
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                currentIndex: 1,
                pageSize: 24,
                total: 0,
                last: true,
                arr: [],
                totalPage: 9,
                pageList: [],
                isShow: true,
                imgUrl: "",
                data: {},
                dowmUrl: "",
                num: 0,
                val: ""
            };
        },
        watch: {
            total(newVal) {
                this.pageData();
            },
            currentPage(newVal) {
                // console.log(123);
                this.currentIndex = newVal;
                this.pageData();
            }
        },

        methods: {
            search() {
                let name = this.val;
                this.pageApi(name);
                // this.val = "";
            },
            down() {
                location.href = this.data.url;
            },
            back() {
                if (this.num) {
                    this.imgUrl = this.data.imageFront;
                    this.num = 0;
                } else {
                    this.imgUrl = this.data.imageBack;
                    this.num = 1;
                }
            },
            details(imgUrl) {
                if (imgUrl) {
                    this.data = imgUrl;
                    this.imgUrl = this.data.imageFront;

                    this.isShow = !this.isShow;
                } else {
                    this.isShow = !this.isShow;
                }
            },
            previous() {
                if (this.val) {
                    if (this.currentIndex != 1) {
                        this.currentIndex--;
                        this.pageData();
                        this.pageApi(this.val);
                    }
                    return;
                } else {
                    if (this.currentIndex != 1) {
                        this.currentIndex--;
                        this.pageData();
                        this.pageApi();
                    }
                    return;
                }
            },
            current(item) {
                if (this.val) {
                    if (item != "..." && item != this.currentIndex) {
                        this.currentIndex = item;
                        this.pageData();
                        this.pageApi(this.val);
                    }
                    return;
                } else {
                    if (item != "..." && item != this.currentIndex) {
                        this.currentIndex = item;
                        this.pageData();
                        this.pageApi();
                    }
                }
            },
            next() {
                if (this.val) {
                    if (this.total > this.currentIndex) {
                        this.currentIndex++;
                        this.pageData();
                        this.pageApi(this.val);
                    }
                    return;
                } else {
                    if (this.total > this.currentIndex) {
                        this.currentIndex++;
                        this.pageData();
                        this.pageApi();
                    }
                    return;
                }
            },
            pageData() {
                let list = new Array();
                let total = "";
                if (this.last) {
                    total = this.total;
                } else {
                    total = this.total > this.totalPage ? 10 : this.total;
                }
                if (this.totalPage >= total) {
                    for (var i = 1; i <= total; i++) {
                        list.push(i);
                    }
                } else {
                    const middle = Math.ceil(this.totalPage / 2);
                    let start = this.currentIndex - (middle - 1);
                    let end = this.currentIndex + (this.totalPage - middle);
                    if (start <= 1) {
                        start = 1;
                        end = this.totalPage;
                        for (var i = start; i <= end; i++) {
                            list.push(i);
                        }
                        list.push("...");
                        if (this.last) {
                            list.push(this.total);
                        }
                    } else if (end >= this.total) {
                        list.push(1);
                        list.push("...");
                        start = this.total - this.totalPage + 1;
                        end = this.total;
                        for (var i = start; i <= end; i++) {
                            list.push(i);
                        }
                    } else {
                        list.push(1);
                        list.push("...");
                        start = start + 1;
                        end = end - 1;
                        for (var i = start; i <= end; i++) {
                            list.push(i);
                        }
                        list.push("...");
                        if (this.last) {
                            list.push(this.total);
                        }
                    }
                }
                this.pageList = list;
            },
            pageApi(name) {
                if (name) {
                    var data = {
                        pageNo: this.currentIndex,
                        pageSize: this.pageSize,
                        name: name
                    };
                } else {
                    var data = {
                        pageNo: this.currentIndex,
                        pageSize: this.pageSize
                    };
                }
                var url = "https://www.99mention.com/card/api/model/card_model_app";

                this.axios
                    .post(url, data, {
                        headers: {
                            "Content-Type": "application/json;charset=UTF-8"
                        }
                    })
                    .then(res => {
                        var data = res.data;
                        console.log(data);
                        if (data.success) {
                            this.arr = data.data.dataList;
                            this.total = data.data.totalPage;
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });
            }
        },
        created() {
            this.pageApi();
            // this.pageData();
        },
        mounted() {}
    };
</script>
<style lang="scss" scoped>
    @import "../../style/mixin";

    .share_page {
        background-color: #fff;
        padding-top: 100px;
        position: relative;

        .head_backgund {
            height: 240px;
            background: url("../../images/banner.png") center no-repeat;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;

            span {
                font-family: MicrosoftYaHei;
                font-size: 60px;
                display: inline-block;
                color: #fff;
            }

            p {
                height: 37px;
                font-size: 36px;
                color: #fff;
            }
        }

        .pageCenter {
            // width: 1440px;
            width: 1228px;
            background-color: rgba(255, 255, 255, 1);
            padding: 0;

            // background: #f00;
            .head_title {
                height: 89px;
                line-height: 89px;
                font-family: MicrosoftYaHei;
                font-size: 20px;
                font-weight: normal;
                font-stretch: normal;
                color: #666666;

                input {
                    // background: #f00;
                    float: right;
                    height: 30px;
                    width: 250px;
                    margin-top: 25px;
                    border: 1px solid #000;
                    border-radius: 20px;
                    padding-left: 12px;
                    margin-right: 5px;
                }

                button {
                    background: #f19837;
                    color: #fff;
                    margin-right: 30px;
                    float: right;
                    height: 30px;
                    margin-top: 25px;
                    border-radius: 15px;
                    padding: 5px 20px;
                }
            }

            .share_content {
                width: 280px;
                height: 176px;
                background: #0ff;
                display: inline-block;
                margin-right: 27px;
                margin-bottom: 39px;
                box-shadow: 13px 15px 10px 0px rgba(20, 14, 2, 0.1);
                border-radius: 6px;

                img {
                    width: 100%;
                    height: 100%;
                }

                span {
                    text-shadow: 13px 15px 10px 0px rgba(20, 14, 2, 0.1);
                    font-size: 15px;
                    // color: #ccc;
                }
            }

            .share_foot {
                // background: #f00;
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 30px;
                margin-top: 41px;

                .page-btn {
                    // background: #f00;
                    height: 40px;
                    width: 40px;
                    text-align: center;
                    line-height: 40px;
                    margin: 0 10px;
                    background-color: #fcfcfc;
                    border-radius: 3px;
                    border: solid 1px #999999;
                    font-family: MicrosoftYaHei;
                    font-size: 14px;
                    color: #666;
                    cursor: pointer;

                    &.none {
                        color: #aeaeae;
                    }

                    &.more {
                        border-color: transparent;
                        padding: 0;
                        min-width: 32px;
                        background-color: inherit;
                    }

                    &.act {
                        // background-color: #006cdb;
                        background-color: #f19837;
                        color: #fff;
                        border-color: #f1f1f1;
                        // border-width: 2px 0;
                    }

                    &:last-child {
                        margin-right: 0;
                        width: 64px;
                    }

                    &:first-child {
                        margin-right: 0;
                        width: 64px;
                    }
                }
            }

            .details {
                height: 833px;
                // background: #f00;
                display: flex;
                justify-content: center;

                .detailsConten {
                    width: 1200px;
                    height: 756px;
                    background-color: #ffffff;
                    box-shadow: 0px 14px 30px 0px rgba(20, 14, 2, 0.1);
                    border-radius: 16px;
                    position: absolute;
                    top: 316px;
                    padding: 0 40px;

                    .detailHead {
                        // background: #f00;
                        height: 95px;
                        line-height: 95px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        .detailHeadRight {
                            display: inline-block;
                            width: 27px;
                            height: 27px;
                            background: url("../../images/close.png") center no-repeat;
                        }
                    }

                    .detailBody {
                        width: 901px;
                        height: 601px;
                        // background-color:rgba($color: #CCC, $alpha: .6);
                        background: rgba(222, 222, 222, 0.3);
                        border-radius: 6px;
                        float: left;
                        padding: 74px 56px 52px 56px;

                        .detailBodyContent {
                            width: 784px;
                            height: 462px;
                            // background: #f00;
                            box-shadow: 40px 40px 5px rgba(222, 222, 222, 1);

                            img {
                                width: 100%;
                            }
                        }
                    }

                    .detailBodyRight {
                        // display: inline-block;
                        margin-left: 30px;
                        background: #f00;
                        float: left;
                        height: 601px;
                        position: relative;

                        button {
                            position: absolute;
                            bottom: 0;
                            width: 160px;
                            height: 56px;
                            background-color: #f19837;
                            border-radius: 8px;
                        }

                        button:first-child {
                            margin-bottom: 76px;
                            background: url("../../images/back.png") center no-repeat;
                        }

                        button:last-child {
                            background: url("../../images/down.png") center no-repeat;
                        }
                    }
                }
            }
        }
    }
</style>